import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=1c82ab8c&scoped=true"
import script from "./CreateCampaign.vue?vue&type=script&lang=ts"
export * from "./CreateCampaign.vue?vue&type=script&lang=ts"
import style0 from "./CreateCampaign.vue?vue&type=style&index=0&id=1c82ab8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82ab8c",
  null
  
)

export default component.exports